module.exports = __webpack_public_path__ + "static/media/cam1.f9cb5d9b.gif";